import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getSurveyValidation: null,
  getSurveyValidationClear: null,
  getSurveyValidationRequest: null,
  getSurveyValidationSuccess: null,
  getSurveyValidationFailure: ['error'],
  hideSurvey: null
});

export { Creators, Types };
